<mat-expansion-panel [expanded]="true" showToggle="false" class="matExpansion-selected">
    <mat-expansion-panel-header>
        <mat-panel-title> <b class="disable_ripple_font"> PRESCHOOL (CURRENTLY ENROLLED IN GRADES P3-P5)
            </b>
			<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_Preschool_Overview'"></help-text-btn>
        </mat-panel-title>

    </mat-expansion-panel-header>

    <form [formGroup]="frmPreSchool">
        <div class="row">
            <div class="col-3">
                <mat-label><b>Enrolled in a non-MEP preschool? </b>
					<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_Preschool_EnrolledInNonMEPPreschool'"></help-text-btn>
                </mat-label>
                
                <mat-radio-group aria-label name="radioNonmep" formControlName="radioNonmep" id="radioNonmep">
                    <div class="column">
                        <mat-radio-button [color]="'primary'" class="example-radio-button"
                            value="1">Yes</mat-radio-button>
                    </div>
                    <div class="column">
                        <mat-radio-button [color]="'primary'" class="example-radio-button"
                            value="2">No</mat-radio-button>
                    </div>
                </mat-radio-group>


            </div>
            <div class="col-3">
                <mat-label><b>Where?</b>
					<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_Preschool_Where'"></help-text-btn>
                </mat-label>

                <div class="col">
                    <mat-form-field>
                        <input matInput type="string" placeholder="Enter the Where?" formControlName="where"
                            (focusout)="updateChangeValue()" />
                    </mat-form-field>
                </div>
            </div>
            <div class="col-3">
                <mat-label><b>Comments</b>
					<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_Preschool_Comments'"></help-text-btn>
                </mat-label>
                
                <div class="col">
                    <textarea rows="7" cols="50" type="string" formControlName="preSchoolComments"
                        (focusout)="updateChangeValue()"></textarea>
                    
                </div>
            </div>
        </div>
    </form>

    <div class="row" *ngIf="(action==2 || action==3)" style="padding-top: 30px" >
        <mat-accordion>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Past Edit - {{this.trackHistories.inaHistory.length}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div *ngIf="this.trackHistories.inaHistory.length>=1">
                    <app-past-edit [section]="this.section"></app-past-edit>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</mat-expansion-panel>